import {Component, Inject, isDevMode, OnDestroy, OnInit} from '@angular/core';
import {Observable, Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {AngularFireDatabase} from "@angular/fire/compat/database";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatSelectChange} from "@angular/material/select";
import {EventModel} from "../../../interfaces/EventModel";
import {Centre} from "../../../interfaces/Centres";
import {FullChild} from "../../../interfaces/FullChild";
import {ChildObject} from "../events.component";
import {environment} from "../../../../environments/environment";
import {UserRole} from "../../rename/add-user-role/add-user-role.component";
import {PermissionType} from "../../employee/PermissionType.enum";
import {VolunteerService} from "../../../modules/volunteer/volunteer.service";

@Component({
    selector: 'app-create-event',
    templateUrl: './create-event.component.html',
    styleUrls: ['./create-event.component.scss']
})

export class CreateEventComponent implements OnInit, OnDestroy {
    private _destroyed$ = new Subject<void>();
    env = isDevMode() ? environment.testMode : environment.productionMode
    centre$ = this.mFirestore.collection<Centre>(this.env.centres).valueChanges({idField: 'id'})
    timeSelected: any
    myForm!: FormGroup
    locations$: Observable<unknown[]>
    eventTypes$: Observable<any[]>
    volunteersList: any[] = [];
    eventFor = 'Centre'
    mode: 'add' | 'edit';
    isEdit = false;
    currentEvent: any;
    codeSelected: string | null = null;  // Added proper type definition

    constructor(
        private mDatabase: AngularFireDatabase,
        private mFirestore: AngularFirestore,
        private _matSnackbar: MatSnackBar,
        private volunteerService: VolunteerService,
        private matDialogRef: MatDialogRef<CreateEventComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.mode = data?.mode || 'add';
        this.currentEvent = data?.event;
        this.isEdit = this.mode === 'edit';

        this.locations$ = this.mDatabase.list('types/Locations').valueChanges()
        this.eventTypes$ = this.mDatabase.list('types/Event Types').valueChanges()
        this.initializeForm();
    }

    private initializeForm() {
        this.myForm = new FormGroup({
            eventName: new FormControl('', Validators.required),
            eventType: new FormControl('', Validators.required),
            eventDate: new FormControl('', Validators.required),
            eventFor: new FormControl(this.eventFor, Validators.required),
            code: new FormControl(null, Validators.required),
            eventTime: new FormControl('', Validators.required),
            description: new FormControl('', Validators.required),
            name: new FormControl('', Validators.required),
            email: new FormControl('', Validators.required),
            number: new FormControl('', Validators.required),
            status: new FormControl('pending', Validators.required),
            volunteer: new FormControl([]),
        });

        if (this.isEdit && this.currentEvent) {
            // Convert Timestamp to Date for form
            const eventDate = this.currentEvent.eventDate?.toDate() || new Date();
            const eventTime = this.currentEvent.eventTime?.toDate() || new Date();

            this.myForm.patchValue({
                ...this.currentEvent,
                eventDate: eventDate,
                eventTime: eventTime
            });
        } else if (this.data?.date) {
            // If creating from calendar click, set the date
            this.myForm.patchValue({
                eventDate: this.data.date
            });
        }
    }
  ngOnInit(): void {
    this.loadVolunteers();
  }

  loadVolunteers() {
    this.volunteerService.getVolunteers().pipe(takeUntil(this._destroyed$)).subscribe({
      next: (data) => {
        this.volunteersList = data;
        console.log('Volunteers loaded:', this.volunteersList);
      },
      error: (err) => {
        console.error('Error loading volunteers:', err);
      },
      complete: () => {}
    });
  }
  selectVolunteer(event: MatSelectChange) {
    const selected = event.value;
    console.log('Selected Volunteer:', selected);
    // Do something with selected.id or selected.name
  }

//GETTERS
    get eventName() {
        return this.myForm.get('eventName')
    }

    get eventType() {
        return this.myForm.get('eventType')
    }

    get description() {
        return this.myForm.get('description')
    }

    get eventTime() {
        return this.myForm.get('eventTime')
    }

    get Name() {
        return this.myForm.get('Name')
    }

    get email() {
        return this.myForm.get('email')
    }

    get number() {
        return this.myForm.get('number')
    }



    createEvent() {
        if (this.myForm.valid) {
            const eventData = this.myForm.value;

            if (this.isEdit) {
                // Update existing event
                this.mFirestore.collection(this.env.events)
                    .doc(this.currentEvent.key)
                    .update(eventData)
                    .then(() => {
                        this._matSnackbar.open('Event Updated', '', {duration: 3000});
                        this.matDialogRef.close();
                    });
            } else {
                // Create new event
                this.mFirestore.collection(this.env.events)
                    .add(eventData)
                    .then(() => {
                        this._matSnackbar.open('Event Created', '', {duration: 3000});
                        this.matDialogRef.close();
                    });
            }
        } else {
            this._matSnackbar.open('Please enter all fields properly', '', {duration: 3000});
        }
    }

    deleteEvent() {
        if (this.isEdit && this.currentEvent?.key) {
            if (confirm('Are you sure you want to delete this event?')) {
                this.mFirestore.collection(this.env.events)
                    .doc(this.currentEvent.key)
                    .delete()
                    .then(() => {
                        this._matSnackbar.open('Event Deleted', '', {duration: 3000});
                        this.matDialogRef.close('deleted');
                    });
            }
        }
    }

    selectCode($event: MatSelectChange) {
        this.codeSelected = $event.value
        console.log('Code Selected', this.codeSelected)
    }

    public findInvalidControls() {
        const invalid = [];
        const controls = this.myForm.controls;
        for (const name in controls) {
            if (controls[name].invalid) {
                invalid.push(name);
            }
        }
        return invalid;
    }

  cancel() {
    this.matDialogRef.close();

  }

  protected readonly PermissionType = PermissionType;

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }
}
